module.exports = __webpack_public_path__ + "img/screen-manual-7.b7bf644c.png";